<template>
  <div class="card card-info card-tabs">
    <div class="card-header  p-0 pt-1 pl-1">
      <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#tab_1" data-toggle="pill" role="tab" aria-controls="tab_1" aria-selected="true">Course Allotment History</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab_2" data-toggle="pill" role="tab" aria-controls="tab_2" aria-selected="false">Student Details</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content active" id="custom-tabs-four-tabContent">
        <div class="tab-pane fade active show" id="tab_1">
          <div class="row">
            <div class="col-md-4">
              <b>Enter Student Roll #</b>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control" v-mask="'###########'" v-model="rollNum" autofocus required>
                <span class="input-group-append">
                  <button class="btn btn-info btn-flat" type="button" v-on:click="search()">Search</button>
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Course</label>
                <select class="form-control" v-model="StudentWiseCourseAllotmentID" required="required">
                  <option value="0" disabled="disabled">--Select Course--</option>
                  <option v-for="item in courses" v-bind:value="item.StudentWiseCourseAllotmentID">{{item.CourseCode}} - {{item.CourseName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Drop/Fail</label>
                <select class="form-control" v-model="studentDrop" required="required">
                  <option value="0">Drop</option>
                  <option value="1">Fail</option>
                </select>
              </div>
            </div>
            <div class="col-md-12" >
              <div class="input-group">
                <label >Remarks</label>
                <textarea v-model="remarks" style="width:100%;height: 80px"></textarea>
                <!--<quill-editor v-model="remarks" />-->
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="tab_2">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-color" id="bs4">
                  <thead class="bg-info">
                    <tr>
                      <th>Department</th>
                      <th>Program</th>
                      <th>Student Name</th>
                      <th>Father Name</th>
                      <th>Roll#</th>
                      <th>Form#</th>
                      <th>Session</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in students">
                      <td>{{item.DepartmentName}}</td>
                      <td>{{item.ProgramName}}</td>
                      <td>{{item.Name}}</td>
                      <td>{{item.FathersName}}</td>
                      <td>{{item.RollNo}}</td>
                      <td>{{item.FormNo}}</td>
                      <td>{{item.SessionName}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="col-md-12">
        <button class="btn btn-primary float-right" type="button" v-on:click="drop()" style="width:95px" v-if="studentDrop == 0">Drop</button>
        <button class="btn btn-primary float-right" type="button" v-on:click="drop()" style="width:95px" v-else>Fail</button>
      </div>
    </div>
  </div>

</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { quillEditor } from 'vue-quill-editor'
  const axios = require('axios').default;

  export default ({
    components: {
      quillEditor
    },
    data() {
      return {
        rollNum: '',
        studentDrop:0,
        courses: [],
        students:[],
        StudentWiseCourseAllotmentID: 0,
        remarks:" "
      }
    },

    methods: {
      search: function () {
        var vm = this;
        if (vm.rollNum == '') {
          toastr.error("Enter Roll Number");
          return
        }
        startReq();
        axios.post('/api/DCApi/SearchRollNum?rollNum=' + vm.rollNum)
          .then(function (res) {
            if (res.data.status) {

              vm.courses = res.data.course;
              vm.students = res.data.students;
            }
            else {
              toastr.error(res.data.msg)
            }
            endReq();
          })
      },
      drop: function () {
        var vm = this;
        if (vm.rollNum =='') {
          toastr.error("Enter Roll Number");
          return
        }
       
        if (vm.StudentWiseCourseAllotmentID == 0) {
          toastr.error("Select Course");
          return
        }
      
        startReq();
        axios.post('/api/DCApi/Drop?crsID=' + vm.StudentWiseCourseAllotmentID + '&val=' + vm.studentDrop + '&remarks=' + vm.remarks )
          .then(function (res) {
            if (res.data.status) {

              toastr.success("Data Saved","Success");
              setTimeout(function () { window.location.reload() }, 3000);
            }
            else {
              toastr.error("Internal Error")
            }
            endReq();
          })
      },
    }

  })
</script>



// WEBPACK FOOTER //
// src/components/DC/courseDrop.vue